﻿export class ProgressBinding {
  /** The number of beads that will show up in the progress spinner. Defaults to 5.*/
  public beadCount = "@?";

  /** LocalSmall/LocalLarge/Regional. Type of progress control. Default LocalLarge.*/
  public type = "@?";

  /**true/false. Set to false to hide the progress control. */
  public while = "<";

  /** Message to be displayed when the progress control is shown. */
  public message = "<?";
}

("use strict");

export type IndeterminantType = "Regional" | "LocalSmall" | "LocalLarge";

/**
 * Defines the API bindings definition for component
 */
export interface ProgressBindings {
  type: IndeterminantType;
  beadCount: number;
  while: boolean;
  message: string;
}

/**
 * The controller used by progress control
 */
export class ProgressControl implements ProgressBindings {
  // binding interface members:
  public type: IndeterminantType;
  public beadCount: number;
  public while: boolean;
  public message: string;

  // view model members:
  public beads: number[];
  public classType: string;
  public classSize: string;

  // component event methods:
  public $onInit(): void {
    this.refreshView();
  }
  public $onChanges(changesObj: any): void {
    this.refreshView();
  }

  private refreshView(): void {
    // set beads to show:
    if (angular.isUndefined(this.beadCount)) {
      this.beadCount = 5;
    }
    this.beadCount = Number(this.beadCount);
    if (!angular.isNumber(this.beadCount) || this.beadCount < 1) {
      throw new Error(`Invalid beadCount binding specified: ${this.beadCount}`);
    }
    this.beads = new Array(this.beadCount);

    // set class values based on type:
    if (angular.isUndefined(this.type)) {
      this.type = "LocalLarge";
    }

    switch (this.type.toLowerCase()) {
      case "localsmall":
        this.classType = "f-indeterminate-local";
        this.classSize = "f-progress-small";
        break;
      case "locallarge":
        this.classType = "f-indeterminate-local";
        this.classSize = "f-progress-large";
        break;
      case "regional":
        this.classType = "f-indeterminate-regional";
        this.classSize = undefined;
        break;
      default:
        throw new Error(`Invalid type binding specified: ${this.type}`);
    }
  }
}
export const sdProgress: ng.IComponentOptions = {
  bindings: <any>new ProgressBinding(),
  controller: ProgressControl,
  templateUrl: "../ShellCommon/Controls/progress/progress.html",
  transclude: true
};
